import { computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { CardStackSummary } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import findMany from "cc-frontend/helpers/find-many"
import type { PromiseObject } from "cc-frontend/lib/promise-object"
import type EmberStore from "cc-frontend/services/ember-store"
import { extractCardStackTemplateIds } from "cc-frontend/utils/filter-dates/course"
import { compact, concat, flatMap, map, reject, uniq } from "lodash-es"
import styles from "./list.module.css"

interface Args {
  planbook: Planbook
  courses: PromiseObject<Array<Course>>
  chooseTemplate: Function
  createAndAssignTemplate: Function
}

export default class PlanbookTemplatesByCourseListComponent extends Component<Args> {
  readonly styles = styles

  @service("ember-store") store!: EmberStore

  @findMany("templateIds", "card-stack-summary") usedTemplates!: PromiseObject<
    Array<CardStackSummary>
  >

  @computed("args.courses.content.length")
  get templateIds() {
    let planbookTemplateIds = map(
      get(this.args.planbook.relationships.cardStackTemplates, "data"),
      (datum) => get(datum, "id")
    )
    let courseTemplateIds = uniq(
      compact(
        flatMap(get(this.args.courses, "content"), (course) => extractCardStackTemplateIds(course))
      )
    )
    return reject(uniq(concat(planbookTemplateIds, courseTemplateIds)), (el) => el === "")
  }

  get noCoursesHaveTemplates() {
    let courseTemplateIds = uniq(
      compact(flatMap(this.args.courses.content, (course) => extractCardStackTemplateIds(course)))
    )
    return courseTemplateIds.length === 0
  }
}
